import usePaymentPanel from 'FormsUI/components/hooks/payment/usePaymentPanel';
import PaymentLinkButtonsGroup from './PaymentLinkButtonsGroup';
import ZeroState from './ZeroState';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentActions = ({
  selectedPaymentLinks,
  showZeroState,
  onDelete
}) => {
  const {
    handlePaymentSelect
  } = usePaymentPanel();
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "200",
    as: "div",
    children: showZeroState ? /*#__PURE__*/_jsx(ZeroState, {
      openPaymentTab: handlePaymentSelect
    }) : selectedPaymentLinks.map(({
      label,
      value
    }) => {
      if (!value) return null;
      return /*#__PURE__*/_jsx(PaymentLinkButtonsGroup, {
        label: label,
        onEdit: handlePaymentSelect,
        onDelete: () => onDelete(value)
      }, value);
    })
  });
};
export default PaymentActions;